import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa' || 'md'
  },
  theme: {
    light: true,
    themes: {
      dark: {
        background: '#EEEEEE'
      },
      light: {
        primary: '#A88E68',
        secondary: '#343434',
        steii: '#A88E68',
      },
    }
  }
});
